import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class LoanDetailsTableLoanOfficerEmail extends Component<{ email: string }> {
    render() {
        return <OptionalTableCell title='Loan Officer Email'>
            {this.props.email}
        </OptionalTableCell>;
    }
}